import { fetchGraphql } from '@zoopla/fetch-graphql';
import createDynamicAgentPhone from './DynamicNumber.mutation.graphql';
import {
    Mutation,
    MutationCreateDynamicAgentPhoneArgs
} from './graphql.generated';

type Result =
    | { type: 'phone'; value: string }
    | { type: 'error'; value: string };

export async function getDynamicNumber(
    branchId: number,
    listingId: number
): Promise<Result> {
    try {
        const { data } = await fetchGraphql<
            Mutation,
            MutationCreateDynamicAgentPhoneArgs
        >(createDynamicAgentPhone, {
            input: {
                branchId: branchId,
                listingId: listingId
            }
        });

        if (!data?.createDynamicAgentPhone) {
            return {
                type: 'error',
                value: 'unknown_error'
            };
        } else if ('phone' in data.createDynamicAgentPhone) {
            return {
                type: 'phone',
                value: data.createDynamicAgentPhone.phone
            };
        } else if ('errorCode' in data.createDynamicAgentPhone) {
            return {
                type: 'error',
                value: data.createDynamicAgentPhone.errorCode
            };
        } else {
            return {
                type: 'error',
                value: 'unknown_error'
            };
        }
    } catch (e) {
        return { type: 'error', value: 'unknown_error' };
    }
}
